import { AddSubaffiliate } from './add-subaffiliate';
import { CreateOrder } from './create-order';
import { RequestPayout } from './request-payout';

export function Development(): JSX.Element {
  return (
    <div className="flex flex-col gap-5">
      <AddSubaffiliate />
      <CreateOrder />
      <RequestPayout />
    </div>
  );
}
